export const isLoggedIn = () => {

    const user = JSON.parse(localStorage.getItem('auth'));

    return user !== null ? true : false;

}